import cn from 'classnames'

export const FaqItem = ({ question, answer }) => {
    return (
        <div className={cn('w-full md:w-1/2 mx-auto mb-8 FaqItem')}>
            <h1 className={cn('text-left font-bold text-lg text-primary')}>
                {question}
            </h1>
            <div
                className={cn(
                    'text-left font-normal text-base dark:text-white text-black',
                )}
            >
                {answer}
            </div>
        </div>
    )
}
